<template>
  <TaskCard
    style="max-width: 500px"
    class="task"
    :title="task.title"
    title-color="primary"
    :initCollapsed="initCollapsed"
    :showProgress="subtasksPresent"
    :progressPercent="subtasksProgress"
    :done="task.done"
    @toggleCollapse="collapseCallback"
    @toggleDone="toggleDone"
    collapsable
  >
      <div>
        <draggable
          v-if="subtasksPresent"
          v-model="subtasksArray"
          handle=".subtask-handle"
          ghost-class="ghost-task"
          :sort="true"
          group="`subtasks_${task.id}`"
          drag-class="task-drag"
        >
          <template v-for="subtask in subtasksArray">
            <Subtask
              :key="subtask.id"
              :subtask="subtask"
              class="mb-1 subtask-handle"
            />
          </template>
        </draggable>

        <div class="flex items-center">
          <feather-icon v-if="addSubTaskSkeleton" icon="PlusCircleIcon" class="w-5 mr-2 cursor-pointer text-primary bold" @click="saveSkeleton" />
          <feather-icon v-else icon="PlusIcon" class="w-5 mr-2" />
          <vs-input class="inputx skeleton-input" ref="skeleton_input" @keyup.enter.native="saveSkeleton" placeholder="Add Sub Task" v-model="addSubTaskSkeleton" />
        </div>
      </div>
<!--     <div>
      <div class="flex items-center">
      <feather-icon icon="CheckSquareIcon" class="w-5 mr-2" />
      <p >Subgoal1</p>
    </div>
        <div class="flex items-center">
      <feather-icon icon="SquareIcon" class="w-5 mr-2" />
      <p >Subgoal2</p>
    </div>
    </div> -->

  </TaskCard>
</template>

<script>
import _ from 'lodash'
import TaskCard from './TaskCard'
import Subtask from './Subtask'
import draggable from 'vuedraggable'
import keepOrderBy from '@/helpers/keepOrderBy'

export default {
  components: {
    TaskCard,
    Subtask,
    draggable
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
  },

  // computed: {
  //   titleColor: "primary"
  // }
  data () {
    return {
      addSubTaskSkeleton: null,
      subtasksArray: []
    }
  },
  watch: {
    'subtasks': {
      immediate: true,
      handler () {
        this.subtasksArray = keepOrderBy(this.subtasksArray, this.subtasks, true)
        // console.log('WATCHER loadedSubgoals.size')
        // this.loadSubgoals()
      }
    },
  },
  computed: {
    subtasks () {
      return this.task.subtasks
    },
    initCollapsed () {
      return !(this.subtasksPresent && this.task.opened)
    },
    subtasksPresent () {
      return this.subtasks && this.subtasks.length > 0
    },
    subtasksProgress () {
      return Math.round(100 * _.filter(this.subtasks, 'done').length / this.subtasks.length)
    }
  },
  methods: {
    toggleDone (done) {
      this.task.done = done

      if (done) {
        this.$store.dispatch('PLAY_SOUND_EFFECT', 'tada')
      }
    },
    collapseCallback (collapsed) {
      this.task.opened = !collapsed
      // remote

      if (collapsed === false && !this.subtasksPresent) {
        this.$forceNextTick(() => this.$refs['skeleton_input'].focusInput())
      }
    },
    saveSkeleton () {
      if (this.addSubTaskSkeleton) {
        this.task.subtasks.push({ id: Math.floor(Math.random() * 10000), title: this.addSubTaskSkeleton, done: false })

        this.addSubTaskSkeleton = null
        this.$forceNextTick(() => this.$refs['skeleton_input'].focusInput())
      }
    }
  }
}

</script>
<style lang="scss">
.task {
  .vx-card__header {
    padding: 0.3rem
  }
}
</style>
